import React from 'react';
import styles from './style.module.scss';
import PricingCard from './components/shared/PricingCard';
import RateItem from './components/shared/RateItem';

const Surcharge = ({ values, formatCurrency, formatPercentage }) => {
  return (
    <div className={styles.surcharge}>
      <PricingCard>
        <div className={styles.ratesList}>
          <RateItem 
            label="Surcharge Rate"
            value={formatPercentage(values.rate)}
          />
          <RateItem 
            label="Per Txn"
            value={formatCurrency(values.per_txn)}
          />
          <RateItem 
            label="Monthly Fee"
            value={`${formatCurrency(values.monthly_fee)}/mo`}
          />
        </div>
      </PricingCard>
    </div>
  );
};

export default Surcharge; 